import { ExperienceType } from "@/lib/experienceType";

export * from "./components/ProfJourneyBestPracticeBanner/ProfJourneyBestPracticeBanner";
export * from "./components/ProfJourneyCompanyList/ProfJourneyCompanyList";
export * from "./components/ProfJourneyCompanyModal/ProfJourneyCompanyModal";
export * from "./components/ProfJourneyProjectDetailsModal/ProfJourneyProjectDetailsModal";
export * from "./components/ProfJourneyProjectModal/ProfJourneyProjectModal";
export * from "./components/ProfJourneyStepper/ProfJourneyStepper";

export enum ProfJourneyFormNamespace {
  CompanyEmployment = "prof-journey-company_employment",
  CompanyEntrepreneurship = "prof-journey-company_entrepreneurship",
  ProjectEmployment = "prof-journey-project_employment",
  ProjectEntrepreneurship = "prof-journey-project_entrepreneurship",
  ProjectDetailsEmployment = "prof-journey-proj-details_employment",
  ProjectDetailsEntrepreneurship = "prof-journey-proj-details_entrepreneurship",
}

export const COMPANY_EXP_TYPE_TO_NAMESPACE = {
  [ExperienceType.Employment]: ProfJourneyFormNamespace.CompanyEmployment,
  [ExperienceType.Entrepreneurship]:
    ProfJourneyFormNamespace.CompanyEntrepreneurship,
} as Record<Partial<ExperienceType>, string>;

export const PROJECT_EXP_TYPE_TO_NAMESPACE = {
  [ExperienceType.Employment]: ProfJourneyFormNamespace.ProjectEmployment,
  [ExperienceType.Entrepreneurship]:
    ProfJourneyFormNamespace.ProjectEntrepreneurship,
} as Record<Partial<ExperienceType>, string>;

export const DETAILS_EXP_TYPE_TO_NAMESPACE = {
  [ExperienceType.Employment]:
    ProfJourneyFormNamespace.ProjectDetailsEmployment,
  [ExperienceType.Entrepreneurship]:
    ProfJourneyFormNamespace.ProjectDetailsEntrepreneurship,
} as Record<Partial<ExperienceType>, string>;
